import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();

  const handleBlogClick = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate('/blog');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handlePageNavigation = (e: React.MouseEvent, path: string) => {
    e.preventDefault();
    navigate(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleHomeClick = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate('/');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <img 
              src="https://static.readdy.ai/image/5bafd8ffd7fb21c6f0de9feb5d9748a4/c1be380ac30fb2709bd46f38b7dd63ed.png" 
              alt="Auralis Consulting" 
              className="h-14 mb-6"
            />
            <p className="text-gray-400 leading-relaxed mb-6">
              Strategic business consulting solutions for corporate excellence and sustainable growth in global markets.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-white font-bold text-lg mb-6">Services</h4>
            <ul className="space-y-3">
              <li><a href="#services" className="hover:text-blue-400 transition-colors cursor-pointer">Corporate Strategy</a></li>
              <li><a href="#services" className="hover:text-blue-400 transition-colors cursor-pointer">Tax Optimization</a></li>
              <li><a href="#services" className="hover:text-blue-400 transition-colors cursor-pointer">International Setup</a></li>
              <li><a href="#services" className="hover:text-blue-400 transition-colors cursor-pointer">IT Network Management</a></li>
              <li><a href="#services" className="hover:text-blue-400 transition-colors cursor-pointer">Staff Provision</a></li>
              <li><a href="#services" className="hover:text-blue-400 transition-colors cursor-pointer">IT Consulting</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold text-lg mb-6">Company</h4>
            <ul className="space-y-3">
              <li><a href="#about" className="hover:text-blue-400 transition-colors cursor-pointer">About Us</a></li>
              <li><a href="#process" className="hover:text-blue-400 transition-colors cursor-pointer">Our Process</a></li>
              <li><a href="#contact" className="hover:text-blue-400 transition-colors cursor-pointer">Contact</a></li>
              <li><a href="/blog" onClick={handleBlogClick} className="hover:text-blue-400 transition-colors cursor-pointer">Blog</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold text-lg mb-6">Contact Info</h4>
            <ul className="space-y-4">
              <li className="flex items-start">
                <i className="ri-map-pin-line text-blue-400 mr-3 mt-1"></i>
                <a 
                  href="https://maps.app.goo.gl/yhbu2KWFY5pvqvw99" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-blue-400 transition-colors cursor-pointer"
                >
                  Compass Building Al Shohada Road,<br />AL Hamra Industrial Zone-FZ<br />Ras Al Khaimah
                </a>
              </li>
              <li className="flex items-center">
                <i className="ri-phone-line text-blue-400 mr-3"></i>
                <span>+971 56 718 2619</span>
              </li>
              <li className="flex items-center mb-3">
                <i className="ri-mail-line text-blue-400 mr-3"></i>
                <a href="mailto:auralisconsult@gmail.com" className="hover:text-blue-400 transition-colors">
                  auralisconsult<span style={{display: 'none'}}>null</span>@<span style={{display: 'none'}}>null</span>gmail.com
                </a>
              </li>
              <li className="flex items-start">
                <i className="ri-time-line text-blue-400 mr-3 mt-1"></i>
                <div>
                  <p>Monday - Friday</p>
                  <p>9:00 AM - 6:00 PM</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-center md:text-left">
              <p className="text-gray-400 text-sm">
                © {currentYear} Auralis Consulting. All rights reserved.
              </p>
            </div>
            <div className="flex items-center space-x-6 text-sm mt-4 md:mt-0">
              <a href="/legal" onClick={(e) => handlePageNavigation(e, '/legal')} className="hover:text-blue-400 transition-colors cursor-pointer">Legal Notice</a>
              <a href="/privacy-policy" onClick={(e) => handlePageNavigation(e, '/privacy-policy')} className="hover:text-blue-400 transition-colors cursor-pointer">Privacy Policy</a>
              <a href="/terms-of-service" onClick={(e) => handlePageNavigation(e, '/terms-of-service')} className="hover:text-blue-400 transition-colors cursor-pointer">Terms of Service</a>
              <a href="/" onClick={handleHomeClick} className="hover:text-blue-400 transition-colors cursor-pointer">Web Design</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
